import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {PaymentStore} from "../../../../State";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFramePaymentsProcessor} from "../../../../services/IFramePaymentsProcessor";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";


class ArticleDetailsStyle extends StyleSheet {
    @styleRule
    currentArticle = {
        padding: "0 24px",
        display: "flex !important",
        justifyContent: "center",
        alignItems: "baseline",
        opacity: 1,
    };

    @styleRule
    title = {
        flex: 1,
        maxWidth: this.themeProps.FIT_CONTENT,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: 14,
        fontStyle: "italic",
        color: this.themeProps.MERCHANT_3,
    };

    @styleRule
    articlePriceContainer = {
        fontSize: 12,
        paddingLeft: 8,
        color: this.themeProps.MERCHANT_2,
    };
}

@registerStyle(ArticleDetailsStyle)
@autoredraw(PaymentStore)
export class ArticleDetails extends UI.Element {
    render() {
        const {styleSheet} = this;
        const currentArticle = iFramePaymentsProcessor.currentArticle;
        const payment = currentArticle ? PaymentStore.get(currentArticle.purchaseId) : null;

        if (!payment) {
            return <div/>;
        }

        return [
            <div className={styleSheet.currentArticle}>
                <div className={styleSheet.title}>{currentArticle.title}</div>
                <div className={styleSheet.articlePriceContainer}>{payment.getAmount()}</div>
            </div>
        ];
    }
}
